/**
 * Shown when a file other than a PDF is dropped where a check PDF goes. react-dropzone never calls
 * `onDrop` with a refused file, so without it a dropped spreadsheet just did nothing (Super
 * Coffee's Meijer remittance, 2026-10-23).
 */
export const NOT_A_CHECK_PDF_TOAST = {
  variant: "destructive" as const,
  title: "Only a check PDF can be dropped here",
  description: "To book a spreadsheet remittance (XLSX, XLS, CSV), upload it on the File imports page under “Upload Backup or Check for AI Parsing”.",
}
